<template>
<div class="main">
	<top-header></top-header>
    <router-view></router-view>
	<bottom-footer></bottom-footer>
	<right-fix></right-fix>
	
</div>
</template>

<script>
	import topHeader from '../../components/pc/header';
	import bottomFooter from '../../components/pc/footer';
	import rightFix from '../../components/pc/right';
	
	export default {
		name :'center',
		data(){
			return{}
		},
		mounted(){
			
		},
		methods:{

		},
		computed:{
            onRoutes(){
                return this.$route.path.replace('/','');
            }
        },
		components:{
			topHeader,bottomFooter,rightFix
		}
	}
</script>

<style scoped>
	
</style>


// WEBPACK FOOTER //
// src/components/pc/center.vue